import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-request-form',
  templateUrl: './request-form.component.html',
  styleUrls: ['./request-form.component.scss']
})
export class RequestFormComponent implements OnInit {

  @Input('form') the_form = {
    request_type: 'account',
    request_title: 'Account aanvragen',
    request_explainer: 'Heeft u nog geen account bij onze webshop, laat uw gegevens achter en wij maken een account voor u aan.',
    thank_you_header: '',
    thank_you_lines: [
       'We will process your request within the next 3 tp 5 bussiness days. You will get an email message as soon as your company is listed in our systems.',
       'You will be assigned a Philips customer number and you may use this to sign up for an account in this shop and will be able to use our special promotions for dental profesionals'
    ]
  };
  
  processing_subscribe: boolean = false;
  processing_success: boolean;
  processing_failed: boolean;
  user_email: string;
  
  constructor(public dataService: DataService) { }

  ngOnInit() {
    if(!!this.dataService.user_info && !this.dataService.user_info.name)
    this.dataService.user_info.name = this.dataService.subuser_info.first_name + ' ' + this.dataService.subuser_info.last_name;
    if( !!this.dataService.signup_form ){
      this.the_form = this.dataService.signup_form;
    }
  }

  get_default(q){
    if( !this.dataService.user_info || !this.dataService.user_info[q.field] ){
      return null;
    }
    return this.dataService.user_info[q.field];
  }

  isNumber(val): boolean { return typeof val === 'number'; }
  isString(val): boolean { return typeof val === 'string'; }



  handle_submit(event, target){
    event.preventDefault();
    let sub_form = <any>document.getElementById('subForm');
    let data = {request_type: 'account'};
    if(!!this.the_form && !!this.the_form.request_type){
      data.request_type = this.the_form.request_type;     
    }
 
    if( !!this.dataService.user_info ){
      data['ext_id'] = this.dataService.user_info.ext_id; // powercerv ID if it is known
    }
    for(let el of sub_form.elements){
      if (!!el.name){
        data[el.name] = el.value;
        if( !!el.value ){
          // special case for booleans
          if (el.value.toUpperCase() === 'TRUE') data[el.name] = true;
          if (el.value.toUpperCase() === 'FALSE') data[el.name] = false;
        }
      }
      if (!!el.dataset.field){
        data[el.dataset.field] = el.value;
      }
    }
    this.processing_subscribe = true;
    this.processing_success = null;
    this.user_email = data['email'];

    this.dataService.post_new_user_request(data).subscribe(res =>{
      console.log(res);
      this.processing_subscribe = false;
      if( !!res['status'] && res['status'] === "ERROR" ){
        this.processing_success = false;
        this.processing_failed = true;
      } else {
        this.processing_success = true;
      }
      //this.close_popup('aanmelden');
    }, 
    err =>{
      console.error(err);
      this.processing_subscribe = false;
      this.processing_success = false;
      // this.close_popup('aanmelden');
    })
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/request-form/request-form.component.ts